import { Alert, Link } from "@alpacahq/ui/old";

export const BankLinkageAlert = () => (
  <Alert
    variant="warning"
    message={
      <span>
        Your account is blocked from initiating Wire Transfers.
        <br />
        Please reach out to{" "}
        <Link href="mailto:support@alpaca.markets">support@alpaca.markets</Link>
        .
      </span>
    }
  />
);
